export default {
  // Header
  "sd.header.badge": "Service Desk 24/7",
  "sd.header.back": "Back",
  "sd.header.active": "Active Desk 24/7",

  // Hero slides
  "sd.hero.slide1.tag": "IT Service Management",
  "sd.hero.slide1.title": "World-Class",
  "sd.hero.slide1.highlight": "IT Service Desk",
  "sd.hero.slide1.subtitle": "Comprehensive incident, request and change management with ITIL processes and guaranteed SLAs. 24/7 support for uninterrupted operations.",
  "sd.hero.slide1.cta": "View services",

  "sd.hero.slide2.tag": "Incident Management",
  "sd.hero.slide2.title": "Resolution in",
  "sd.hero.slide2.highlight": "Record Time",
  "sd.hero.slide2.subtitle": "Multi-level L1/L2/L3 support teams with automated ticketing tools, knowledge base and intelligent escalation to minimize downtime.",
  "sd.hero.slide2.cta": "View capabilities",

  "sd.hero.slide3.tag": "Guaranteed Availability",
  "sd.hero.slide3.title": "SLAs with",
  "sd.hero.slide3.highlight": "99.9% Uptime",
  "sd.hero.slide3.subtitle": "Proactive infrastructure monitoring, immediate response and continuous improvement with real-time metrics. Your operation always available.",
  "sd.hero.slide3.cta": "Request consulting",

  "sd.hero.backHome": "Back to Home",

  // Dashboard
  "sd.dashboard.tag": "Operational Metrics",
  "sd.dashboard.title": "Service Desk",
  "sd.dashboard.highlight": "Dashboard",
  "sd.dashboard.subtitle": "Real-time performance metrics from our active 24/7 service desk",
  "sd.dashboard.teamTitle": "+200 Specialists",
  "sd.dashboard.teamSubtitle": "Ready to help you 24/7",

  "sd.dashboard.m1.label": "Tickets resolved today",
  "sd.dashboard.m2.label": "SLAs met",
  "sd.dashboard.m3.label": "Active agents",
  "sd.dashboard.m4.label": "Response time",

  // Features
  "sd.features.tag": "Services",
  "sd.features.title": "Service Desk",
  "sd.features.highlight": "Capabilities",
  "sd.features.subtitle": "An enterprise-class IT service desk with ITIL processes and cutting-edge technology",
  "sd.features.humanTag": "Humanized",
  "sd.features.humanTitle": "People behind the technology",
  "sd.features.humanDesc": "Over 200 certified specialists working to resolve your incidents with empathy, speed and excellence.",

  "sd.features.f1.title": "24/7 Help Desk",
  "sd.features.f1.desc": "Continuous multi-level L1/L2/L3 support with real-time ticket registration, classification and resolution.",
  "sd.features.f1.stat": "99.9%",
  "sd.features.f1.statLabel": "SLA Guaranteed",

  "sd.features.f2.title": "Incident Management",
  "sd.features.f2.desc": "Structured detection, diagnosis and resolution process with automatic escalation based on criticality.",
  "sd.features.f2.stat": "< 15 min",
  "sd.features.f2.statLabel": "Response time",

  "sd.features.f3.title": "Change Management",
  "sd.features.f3.desc": "ITIL change control with risk assessment, rollback plans and scheduled maintenance windows.",
  "sd.features.f3.stat": "98%",
  "sd.features.f3.statLabel": "Successful changes",

  "sd.features.f4.title": "Knowledge Base",
  "sd.features.f4.desc": "Centralized repository of solutions, FAQs and standard procedures for fast and autonomous resolution.",
  "sd.features.f4.stat": "5000+",
  "sd.features.f4.statLabel": "KB Articles",

  "sd.features.f5.title": "Metrics & Reports",
  "sd.features.f5.desc": "Real-time dashboards with service KPIs, ticket trends and end-user satisfaction scores.",
  "sd.features.f5.stat": "4.8/5",
  "sd.features.f5.statLabel": "CSAT Score",

  "sd.features.f6.title": "Omnichannel",
  "sd.features.f6.desc": "Support via phone, email, live chat and self-service portal. Your users choose how to contact you.",
  "sd.features.f6.stat": "5 Channels",
  "sd.features.f6.statLabel": "Available",

  // CTA
  "sd.cta.tag": "Activate Service Desk",
  "sd.cta.title": "Transform your IT support with",
  "sd.cta.subtitle": "Over 200 IT specialists ready to manage your incidents and keep your operation always available",
  "sd.cta.button": "Request free consulting",
  "sd.cta.homeButton": "View main site",
};